// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"380":"WindHome","779":"SolarHome"}[chunkId] + "." + {"380":"c0b4cf4e","779":"50bbeb3b"}[chunkId] + ".css";
};